import { useFormikContext } from 'formik';

import { Location as LocationDS } from 'hb-react/shared/components/formik/components/inputs';

import { type FormValues } from '../types';

export const Location = () => {
  const formik = useFormikContext<FormValues>();

  return (
    <LocationDS
      fieldAddressName="location"
      formik={formik}
      label={s__('JobForm|Location')}
      name="location"
    />
  );
};
